// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"52dd8161","483":"fc531700","596":"3de7586d","698":"892e967c","861":"ab5537bf","901":"a65e4866","905":"022d2e5e","931":"1300eb10"}[chunkId] + ".chunk.js";
};